import { Component, ojs, app, state, v, component } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { pageInfo, formatDate, each, either } from "../../helpers";
import { api, PAGES } from "../../declarations";
import InfiniteScroll from "../Blocks/InfiniteScroll";
import { routes } from "../../backendRoutes";

const h = app("h");

ojs(InfiniteScroll);

export default class Review extends Component {
    page = 1;
    hasMore = true;
    loadingMore = false;
    loadingStats = state(true);
    stats = state({ avgRating: 0, totalReviews: 0 });
    ratings = state([
        { stars: 5, pct: 0 },
        { stars: 4, pct: 0 },
        { stars: 3, pct: 0 },
        { stars: 2, pct: 0 },
        { stars: 1, pct: 0 },
    ]);
    
    selectedRating = state("all");

    selectAllTab() {
        this.selectedRating.value = "all";
        this.page = 1;
        this.hasMore = true;
        dom.empty(dom.get(`[reviews-holder-id='reviews-holder']`));
        this.getReviews(dom.get(`[ifs_marker='true']`), `reviews-holder`);
    }

    selectRatingTab(rating) {
        this.selectedRating.value = rating;
        this.page = 1;
        this.hasMore = true;
        dom.empty(dom.get(`[reviews-holder-id='reviews-holder']`));
        this.getReviews(dom.get(`[ifs_marker='true']`), `reviews-holder`);
    }

    async fetchStats() {
        try {
            let res = await api.get(`${routes.userStats}/reviews/stats`);
            if (res) {
                this.stats.value = {
                    avgRating: res.data.avg_rating,
                    totalReviews: res.data.total_reviews
                };
                this.ratings.value = res.data.ratings;
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loadingStats.value = false;
        }
    }

    $_mounted(componentId) {
        let c = component(componentId);

        if(!c) return;
        c.fetchStats();
    }

    render(...args) {
        pageInfo(PAGES.REVIEWS);

        return h.div(
            { class: "container pb-5 mb-5 py-md-5" },
            // Rating Summary
            h.div(
                { class: "py-4" },
                h.div(
                    { class: "row g-3" },
                    // Overall AVG, COUNT
                    h.div(
                        { class: "col-5" },
                        v(this.stats, (s) => {
                            const avg = s.value.avgRating;
                            const total = s.value.totalReviews;
                            return h.div(
                                {
                                    class: "d-flex flex-column align-items-center justify-content-center gap-2 h-100",
                                },
                                h.h1(
                                    {
                                        class: "fw-600 mb-1",
                                        style: "font-size: 48px; color: #212529; line-height: 1;",
                                    },
                                    avg.toFixed(1),
                                ),
                                h.div(
                                    { class: "d-flex gap-1" },
                                    each([1, 2, 3, 4, 5], (i) =>
                                        h.i({
                                            class: `${i <= Math.floor(avg) ? "bi-star-fill" : i === Math.ceil(avg) && avg % 1 !== 0 ? "bi-star-half" : "bi-star"}`,
                                            style: "color: #ffc107; font-size: 16px;",
                                        }),
                                    ),
                                ),
                                h.span(
                                    {
                                        class: "fw-medium text-secondary",
                                        style: "font-size: 1rem; letter-spacing: 0.5px;",
                                    },
                                    `${total} reviews`,
                                ),
                            );
                        })
                    ),
                    // AVG, COUNT per rating
                    h.div(
                        { class: "col-7" },
                        v(this.ratings, (rts) =>
                            h.div(
                                {
                                    class: "d-flex flex-column justify-content-center gap-1",
                                },
                                each([5, 4, 3, 2, 1], (rating) => {
                                    const pct =
                                        rts.value.find((r) => r.stars === rating)
                                            ?.pct || 0;
                                    return h.div(
                                        {
                                            class: "d-flex align-items-center gap-1",
                                        },
                                        h.div(
                                            {
                                                class: "d-flex align-items-center gap-1",
                                                style: "width: 32px;",
                                            },
                                            h.i({
                                                class: "bi-star-fill",
                                                style: "color: #ffc107; font-size: 12px;",
                                            }),
                                            h.span(
                                                { class: "fw-600 lh-1" },
                                                rating,
                                            ),
                                        ),
                                        h.div(
                                            {
                                                class: "flex-grow-1 rounded-pill",
                                                style: "height: 8px; background-color: #e9ecef;",
                                            },
                                            h.div({
                                                class: "rounded-pill h-100 bg-primary",
                                                style: `width: ${pct}%;`,
                                            }),
                                        ),
                                        h.span(
                                            {
                                                class: "fw-500 text-secondary",
                                                style: "width: 36px; text-align: right;",
                                            },
                                            `${pct}%`,
                                        ),
                                    );
                                })
                            )
                        )
                    ),
                ),
            ),

            // Ratings Tabs
            v(this.selectedRating, (selRating) =>
                h.div(
                    {
                        class: "d-flex flex-row overflow-auto gap-2 py-3 px-1",
                        style: "scrollbar-width: none;",
                    },
                    // "All" Tab
                    h.div(
                        {
                            class: "p-2 rounded-pill d-flex align-items-center justify-content-center gap-1 flex-shrink-0",
                            style: `background-color: ${selRating.value === "all" ? "var(--bs-primary)" : "#e9ecefff"}; color: ${selRating.value === "all" ? "white" : "inherit"}; cursor: pointer; border: 1px solid ${selRating.value === "all" ? "var(--bs-primary)" : "#d4dadfff"}; min-width: 64px;`,
                            onclick: this.method("selectAllTab"),
                        },
                        h.i({ class: "bi-star-fill", style: "font-size: 12px;" }),
                        h.span({ class: "fw-600 lh-1" }, "All"),
                    ),
                    // 5 to 1 Tabs
                    each([5, 4, 3, 2, 1], (rating) =>
                        h.div(
                            {
                                class: "p-2 rounded-pill d-flex align-items-center justify-content-center gap-1 flex-shrink-0",
                                style: `background-color: ${selRating.value === rating ? "var(--bs-primary)" : "#e9ecefff"}; color: ${selRating.value === rating ? "white" : "inherit"}; cursor: pointer; border: 1px solid ${selRating.value === rating ? "var(--bs-primary)" : "#d4dadfff"}; min-width: 64px;`,
                                onclick: this.method("selectRatingTab", rating),
                            },
                            h.i({
                                class: "bi-star-fill",
                                style: "font-size: 12px;",
                            }),
                            h.span({ class: "fw-600 lh-1" }, rating),
                        ),
                    ),
                )
            ),

            // List of Reviews
            h.InfiniteScroll({
                child: h.div({
                    reviews_holder_id: `reviews-holder`,
                }),
                callback: (entries, observer, marker) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;
                        this.getReviews(marker, `reviews-holder`);
                    });
                },
            }),
            ...args,
        );
    }

    async getReviews(marker, holderId) {
        if (!this.hasMore || this.loadingMore) return;
        this.loadingMore = true;

        let spinner = h.Spinner({
            class: "p-3 my-auto mx-auto",
            parent: marker,
            resetParent: true,
        });

        let params = {
            page: this.page,
        };

        if (this.selectedRating.value !== "all") {
            params.rating = this.selectedRating.value;
        }

        try {
            let result = await api.get(`${routes.userStats}/reviews`, params);

            if (result) {
                let reviews = result.data.reviews.data || [];
                let holder = dom.get(`[reviews-holder-id='${holderId}']`);

                for (let review of reviews) {
                    h.ReviewView(review, {
                        parent: holder,
                        class: "mb-3",
                    });
                }

                if (reviews.length < 10 || result.data.reviews.current_page >= result.data.reviews.last_page) {
                    this.hasMore = false;
                } else {
                    this.page++;
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            spinner.remove();
            this.loadingMore = false;
        }
    }

    cleanUp() {
        super.cleanUp();
        this.page = 1;
        this.hasMore = true;
        this.loadingMore = false;
        this.loadingStats.value = true;
        this.selectedRating.value = "all";
    }
}

class ReviewView extends Component {
    render(review, ...args) {
        const emojiMap = [
            {
                stars: 5,
                bi: "bi-emoji-laughing",
                fa: "fa-regular fa-face-grin-stars",
                color: "#3a9200ff",
            },
            {
                stars: 4,
                bi: "bi-emoji-smile",
                fa: "fa-regular fa-face-smile",
                color: "#79970aff",
            },
            {
                stars: 3,
                bi: "bi-emoji-neutral",
                fa: "fa-regular fa-face-meh",
                color: "#a08300ff",
            },
            {
                stars: 2,
                bi: "bi-emoji-frown",
                fa: "fa-regular fa-face-frown",
                color: "#dd5800ff",
            },
            {
                stars: 1,
                bi: "bi-emoji-angry",
                fa: "fa-regular fa-face-angry",
                color: "#ff0019ff",
            },
        ];

        const emoji =
            emojiMap.find((e) => e.stars === review.rating) || emojiMap[2];

        let orderCode = review.order?.order_code || "N/A";
        let due = new Date(
            review.order?.processing_due_at || review.created_at,
        );
        let completed = new Date(
            review.order?.completed_at || review.created_at,
        );
        let diffMins = Math.round((completed - due) / 60000);
        let fulfillmentText =
            diffMins > 0
                ? `Fulfilled ${diffMins} mins late`
                : diffMins < 0
                  ? `Fulfilled ${Math.abs(diffMins)} mins earlier`
                  : `Fulfilled on time`;

        let confirmedStr = review.order?.confirmed_at || review.created_at;
        let confirmedDate = new Date(confirmedStr).toLocaleDateString(
            undefined,
            { month: "short", day: "numeric", year: "numeric" },
        );

        return h.div(
            { class: "border-0 mb-3 rounded" },
            h.div(
                {
                    class: "card",
                    style: "--bs-card-spacer-y: 1.5rem; --bs-card-spacer-x: 1.5rem; --bs-card-bg: #fff; --bs-card-border-color: var(--bs-gray-200);",
                },
                h.div(
                    { class: "card-body d-flex flex-column gap-3" },

                    // Section 1
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-center w-100",
                        },
                        // Far left
                        h.div(
                            { class: "d-flex align-items-center gap-3" },
                            // Emoji
                            h.i({
                                class: `${emoji.bi}`,
                                style: `color: ${emoji.color}; font-size: 40px; line-height: 1;`,
                            }),
                            // Stack of texts
                            h.div(
                                { class: "d-flex flex-column" },
                                h.span(
                                    {
                                        class: "fw-600 text-dark mb-1",
                                        style: "font-size: 1.05rem;",
                                    },
                                    fulfillmentText,
                                ),
                                h.span(
                                    {
                                        class: "text-secondary fw-500",
                                        style: "font-size: 0.85rem;",
                                    },
                                    `#${orderCode} • ${confirmedDate}`,
                                ),
                            ),
                        ),
                        // Far right
                        h.div(
                            {
                                class: "d-flex align-items-center gap-1 border rounded-pill py-1 px-2",
                            },
                            h.i({
                                class: "bi-star-fill",
                                style: `color: #ffc107; font-size: 12px;`,
                            }),
                            h.span({ class: "fw-600 lh-1" }, review.rating),
                        ),
                    ),

                    // Section 2 (optional)
                    either(review.review, () => h.div(review.review)),
                ),
            ),
            ...args,
        );
    }
}

ojs(Review, ReviewView);
